import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-lines',
  templateUrl: './consignment-lines.component.html',
  styleUrls: ['./consignment-lines.component.css']
})
export class ConsignmentLinesComponent implements OnInit {
    argType;

    argValue;

    public itemsListConsigmentLines: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadConsignmentLines() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListConsigmentLines = await this.datatask.Post(330, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadConsignmentLines();
    }

    ngOnInit() {
        this.init();
    }
}
